import { render, staticRenderFns } from "./FormField.vue?vue&type=template&id=53fbc838&scoped=true&lang=pug&"
import script from "./FormField.vue?vue&type=script&lang=js&"
export * from "./FormField.vue?vue&type=script&lang=js&"
import style0 from "./FormField.vue?vue&type=style&index=0&id=53fbc838&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fbc838",
  null
  
)

export default component.exports